"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyResource = exports.RolesResource = exports.EmployeesResource = exports.BranchesResource = void 0;
/** Branches of the caller's own tenant (TZ §8). */
class BranchesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(query) {
        return this.http.getPaginated('branches', { query });
    }
    /** Lightweight list for pickers and branch switchers. */
    summaries(query) {
        return this.http.get('branches/summary', { query });
    }
    get(id) {
        return this.http.get(`branches/${id}`);
    }
    create(payload) {
        return this.http.post('branches', payload);
    }
    update(id, payload) {
        return this.http.patch(`branches/${id}`, payload);
    }
    remove(id) {
        return this.http.delete(`branches/${id}`);
    }
    /** Drawn delivery zones, in precedence order. */
    zones(id) {
        return this.http.get(`branches/${id}/zones`);
    }
    /** Replaces the branch's zones; array order is precedence where they overlap. */
    saveZones(id, zones) {
        return this.http.put(`branches/${id}/zones`, { zones });
    }
}
exports.BranchesResource = BranchesResource;
/** Staff accounts (TZ §46 "Employees"). */
class EmployeesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(query) {
        return this.http.getPaginated('employees', { query });
    }
    get(id) {
        return this.http.get(`employees/${id}`);
    }
    create(payload) {
        return this.http.post('employees', payload);
    }
    /** `isActive: true` re-activates a deactivated account. */
    update(id, payload) {
        return this.http.patch(`employees/${id}`, payload);
    }
    /** Deactivates rather than deleting, so order history keeps its author. */
    deactivate(id) {
        return this.http.post(`employees/${id}/deactivate`);
    }
    resetPassword(id, newPassword) {
        return this.http.post(`employees/${id}/reset-password`, { newPassword });
    }
}
exports.EmployeesResource = EmployeesResource;
/** Roles and the permission catalog (TZ §5). */
class RolesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list() {
        return this.http.get('roles');
    }
    get(id) {
        return this.http.get(`roles/${id}`);
    }
    create(payload) {
        return this.http.post('roles', payload);
    }
    update(id, payload) {
        return this.http.patch(`roles/${id}`, payload);
    }
    remove(id) {
        return this.http.delete(`roles/${id}`);
    }
    /** Full permission catalog, grouped for the role editor UI. */
    permissions() {
        return this.http.get('permissions');
    }
    assignToUser(userId, roleIds, branchIds = []) {
        return this.http.post(`users/${userId}/roles`, { roleIds, branchIds });
    }
}
exports.RolesResource = RolesResource;
/** The caller's own company settings and branding (TZ §49). */
class CompanyResource {
    http;
    constructor(http) {
        this.http = http;
    }
    get() {
        return this.http.get('company');
    }
    update(payload) {
        return this.http.patch('company', payload);
    }
}
exports.CompanyResource = CompanyResource;
//# sourceMappingURL=organization.js.map